import React from 'react'
import { Select, SelectProps } from 'antd'
import '../SAPPCalendar.tailwind.css'

interface IProps extends SelectProps<string | number> {
  value: string | number
  options: { value: string; label: string }[]
  defaultValue?: string
  className?: string
  disabled?: boolean
  onChange?: (e: string | number) => void
}

const SelectBox: React.FC<IProps> = ({
  value,
  options,
  defaultValue,
  className = '',
  disabled,
  onChange,
  ...restProps
}) => {
  return (
    <Select
      defaultValue={defaultValue}
      className={className}
      disabled={disabled}
      options={options}
      value={value}
      getPopupContainer={(trigger) => trigger.parentNode}
      onChange={onChange}
      dropdownAlign={{
        points: ['tl', 'bl'],
        offset: [0, 12],
       }}
      {...restProps}
    />
  )
}

export default SelectBox
